export function useSyncNativeDrawerStatus() {
  console.debug('useSyncNativeDrawerStatus() does do anything on web');
}
